import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import AboutOfficeSection from "./components/AboutOfficeSection";
import AboutNetworkSection from "./components/AboutNetworkSection";
import SupplyChainSection from "./components/SupplyChainSection";
import MatrixSection from "./components/MatrixSection";
import ShellSection from "./components/ShellSection";
import ShellIndustrialSection from "./components/ShellIndustrialSection";
import MicSection from "./components/MicSection";
import LogisticsSection from "./components/LogisticsSection";
import PartnerSection from "./components/PartnerSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="bg-[#0A0F1A] min-h-screen overflow-x-hidden w-full" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <AboutOfficeSection />
        <AboutNetworkSection />
        <SupplyChainSection />
        <MatrixSection />
        <ShellSection />
        <ShellIndustrialSection />
        <MicSection />
        <LogisticsSection />
        <PartnerSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
